import { Outlet, useParams } from "react-router-dom";

import QueryWrapper from "common/components/QueryWrapper";
import { ScreenLayout } from "common/layouts/ScreenLayout";
import type { Wall } from "wall/types/wall.model";
import { useGetWallQuery } from "wall/api/walls.endpoints";
import { useMantineTheme } from "@mantine/core";

export function WallScreenLayout() {
  const { wallId } = useParams<{ wallId: string }>();
  const getWallQuery = useGetWallQuery(wallId!);
  const theme = useMantineTheme();

  return (
    <QueryWrapper query={getWallQuery}>
      {(wall: Wall) => (
        <ScreenLayout theme={{ ...wall, screenType: wall.template }}>
          <div style={{ fontFamily: theme.fontFamily }}>
            <Outlet />
          </div>
        </ScreenLayout>
      )}
    </QueryWrapper>
  );
}
